import React, {useCallback} from 'react';
import {ArrowLeft, ArrowRight, CarouselArrowRightAlt, CarouselArrowLeftAlt} from '../../elements';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {useUnrealUIContext} from '../../../shared/context';

interface ControlsProps {
    onClick: (() => void) | ((e: any) => void);
    disabled?: boolean;
    type?: 'left' | 'right';
    accentColor?: AccentColorOptions;
    small?: boolean;
}

const Arrow = styled.button<{accentColor?: AccentColorOptions}>`
    &&.ue-carousel-btn {
        position: relative;
        top: 50%;
        left: 0px;
        transform: translateY(-50%);
        display: block;
        font-size: 60px;
        line-height: 40px;
        height: 60px;
        width: 60px;
        &.small {
            font-size: 40px;
            height: 40px;
            width: 40px;
        }
        background-color: transparent;
        border-color: transparent;
        color: ${(p) => p.theme.palette.text.primary};
        cursor: pointer;
        border: none;
        display: block;
        padding: 0;
        align-items: center;
        .ue-icon-arrow-left,
        .ue-icon-arrow-right {
            transition: color 0.2s ${(p) => p.theme.easing};
        }
        &:hover {
            &.disabled {
                color: ${(p) => p.theme.palette.text.secondary};
                cursor: default;
            }
            /* inline style is used on the icon color so !important is used to override only on hover */
            &:not(.disabled) .arrow {
                color: ${(p) =>
                    p.accentColor
                        ? p.theme.palette.accent[p.accentColor]
                        : p.theme.palette.text.primary} !important;
            }
        }
        &:focus-visible {
            outline: 1px solid ${(p) => p.theme.palette.misc.outline};
            outline-offset: 2px;
        }
    }
`;

export const ArrowControls = ({
    onClick,
    disabled,
    type,
    accentColor,
    small
}: ControlsProps): JSX.Element => {
    const stopFocusOnClick = useCallback((e) => {
        e.preventDefault();
    }, []);

    const {carousel} = useUnrealUIContext();

    let rightArrow: JSX.Element | undefined =
        type !== 'left' ? (
            <ArrowRight fontSize="inherit" color={disabled ? 'disabled' : 'primary'} />
        ) : undefined;
    let leftArrow: JSX.Element | undefined =
        type === 'left' ? (
            <ArrowLeft fontSize="inherit" color={disabled ? 'disabled' : 'primary'} />
        ) : undefined;

    if (carousel?.icon === 'alt') {
        rightArrow =
            type !== 'left' ? (
                <CarouselArrowRightAlt
                    fontSize="inherit"
                    color={disabled ? 'disabled' : 'primary'}
                />
            ) : undefined;
        leftArrow =
            type === 'left' ? (
                <CarouselArrowLeftAlt
                    fontSize="inherit"
                    color={disabled ? 'disabled' : 'primary'}
                />
            ) : undefined;
    }

    return (
        <Arrow
            accentColor={accentColor}
            className={`ue-carousel-btn ${disabled ? 'disabled' : ''} ${small ? 'small' : ''}`}
            onClick={onClick}
            onMouseDown={stopFocusOnClick}>
            {leftArrow}
            {rightArrow}
        </Arrow>
    );
};
